/**
 * Copy of Kyrgyzstan's yearly invoice-request form (`components/kg-invoice-request.tsx`).
 *
 * Russian only and KG only — the deployment serves `ru` alone — so it lives here,
 * like the legal texts, rather than as forty keys in three catalogues that only
 * one build would ever render. Wording of the notes: coordinator, 2026-11-04
 * (a transfer from Kyrgyzstan to the Uzbek operator goes in USD by SWIFT; VAT is
 * the buyer's as a tax agent). ⚠️ The НК КР article is from that research, not
 * from a lawyer.
 */
export const KG_INVOICE_COPY = {
  open: 'Оплата по счёту (для компаний)',
  openSub: 'Перевод в долларах США по SWIFT',
  title: (plan: string) => `Заявка на счёт — ${plan} на год`,
  amount: (usd: number) => `$${usd}`,
  amountRef: (local: string, source: string) => `≈ ${local} сом по курсу ${source}, справочно`,
  fields: {
    companyName: 'Наименование организации',
    legalForm: 'Форма',
    tin: 'ИНН (14 цифр)',
    legalAddress: 'Юридический адрес',
    signerName: 'ФИО подписанта',
    signerPosition: 'Должность подписанта',
    bankName: 'Банк',
    bankBik: 'БИК',
    bankAccount: 'Расчётный счёт',
    bankSwift: 'SWIFT банка',
    vatPayer: 'Плательщик НДС в Кыргызской Республике',
    startDate: 'Дата начала доступа',
    invoiceEmail: 'E-mail для счёта и акта',
    contact: 'Телефон или Telegram',
    offer: 'Согласен(на) с условиями публичной оферты',
  },
  legalForms: ['ОсОО', 'ИП', 'ОАО', 'ЗАО', 'ГП', 'Другая'],
  yes: 'Да',
  no: 'Нет',
  notes: [
    'Оплата — в долларах США банковским переводом по SWIFT. Комиссии банков (тип OUR) — за счёт плательщика.',
    'НДС 12 % по услугам иностранной компании исчисляет и уплачивает покупатель как налоговый агент (ст. 53 Налогового кодекса КР).',
    'Доступ открывается после зачисления оплаты — обычно 1–3 банковских дня.',
  ],
  submit: 'Отправить заявку',
  submitting: 'Отправляем…',
  error: 'Не удалось отправить заявку. Проверьте поля и попробуйте ещё раз.',
  invalid: 'Заполните все поля: ИНН — 14 цифр, SWIFT — 8 или 11 знаков, согласие с офертой.',
  doneTitle: 'Заявка отправлена',
  done: (n: number, email: string) =>
    `Номер заявки — ${n}. Счёт в долларах придёт на ${email}; доступ откроется после зачисления оплаты.`,
  close: 'Закрыть',
} as const;
